export default __webpack_public_path__ + "static/media/ico_worldMap_SMG.39b1d832.png";